import { TwoFactorAuthEmailComponentService } from "./two-factor-auth-email-component.service";

export class DefaultTwoFactorAuthEmailComponentService
  implements TwoFactorAuthEmailComponentService {
  // no default implementation
}
